import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as Sentry from '@sentry/react'
import axios from 'axios'
import {
    CAC_VALIDATE_ADDRESS_REQUEST,
    validateCustomCardAddressResponse,
} from '../actions/createACard'

function* validateAddress(action) {
    const customCard = action.payload
    const requestData = {
        address_line1: customCard.addressLine1,
        address_line2: customCard.addressLine2,
        city: customCard.city,
        state: customCard.state,
        zip_code: customCard.zip,
    }

    try {
        const { data } = yield axios.request({
            url: `/ajax/validate-address/`,
            method: 'post',
            data: requestData,
        })

        yield put(validateCustomCardAddressResponse(data))
    } catch (e) {
        yield call(Sentry.captureException, e, {
            contexts: {
                data: requestData,
            },
        })
        yield put(validateCustomCardAddressResponse(e.response, '', true))
    }
}

export function* createACardSagas() {
    yield all([takeLatest(CAC_VALIDATE_ADDRESS_REQUEST, validateAddress)])
}

export default createACardSagas
